import { defineMessages } from 'react-intl';

export default defineMessages({
  liquidationOverview: 'Liquidation Overview',
  liquidationOverviewDescription: 'Details about your Loan to Value (LTV) ratio and liquidation.',

  currentLTV: 'Current LTV',
  maximumLTV: 'Maximum LTV',
  liquidationThreshold: 'Liquidation threshold',
  currentAssetPrice: 'Current asset price',
  assetLiquidationPrice: 'Asset Liquidation price',

  collateral: 'Collateral',
  borrow: 'Borrow',
});
